import { is } from '../../../utils';

export function createHeaderTip(
  ...tips: (string | number | null | undefined)[]
): string {
  return tips
    .filter((v) => !is.nullOrUndefined(v))
    .map((tip) => `(${tip})`)
    .join(' ');
}
